import React, { Fragment } from "react";
import { groupDifferencesByAction } from "../AllOrgActivities/helper";
import TagsInput from "react-tagsinput";
import { Col, Row } from "antd";

export const ZipCodeCitiesDetails = ({ data, incomingTitle = "" }) => {
  const renderRegularGroup = (changes, title, type) => {
    if (!changes?.length) return null;
    const incomingZips = changes[0]?.new_value
      ? changes[0]?.new_value?.zip_codes
      : changes[0]?.old_value?.zip_codes;
    const formattedZips = Array.isArray(incomingZips)
      ? incomingZips
      : typeof incomingZips === "string"
      ? incomingZips.split(",").map((zip) => zip.trim())
      : [];
    const incomingCities = changes[0]?.new_value
      ? changes[0]?.new_value?.city_names
      : changes[0]?.old_value?.city_names;
    return (
      <div className="mb-6">
        <h4
          className="ant-typography ant-typography-md font-medium mb-3"
          style={{ textAlign: "left", fontSize: "16px" }}
        >
          {title}
        </h4>
        <Fragment>
          <Row gutter={[32, 32]} className="tagssettingRow" type="flex">
            <Col sm={24} xs={24} md={24} lg={24}>
              <h4
                className="ant-typography ant-typography-md font-medium mb-3"
                style={{ textAlign: "left", fontSize: "16px" }}
              >
                Cities
              </h4>
              <TagsInput
                value={incomingCities || []}
                validationRegex={/^(?=[0-9]*$)(?:.{3}|.{4}|.{5})$/}
                addKeys={[9, 13, 32]}
                onlyUnique
                disabled
                inputProps={{
                  placeholder: null,
                }}
              />
            </Col>
            <Col sm={24} xs={24} md={24} lg={24}>
              <h4
                className="ant-typography ant-typography-md font-medium mb-3"
                style={{ textAlign: "left", fontSize: "16px" }}
              >
                ZipCodes
              </h4>
              <TagsInput
                value={formattedZips || []}
                validationRegex={/^(?=[0-9]*$)(?:.{3}|.{4}|.{5})$/}
                addKeys={[9, 13, 32]}
                onlyUnique
                disabled
                inputProps={{
                  placeholder: null,
                }}
              />
            </Col>
          </Row>
        </Fragment>
      </div>
    );
  };

  const renderModifiedGroup = (changes) => {
    if (!changes?.length) return null;

    return (
      <div className="mb-6">
        <h4
          className="ant-typography ant-typography-md font-medium mb-3"
          style={{ textAlign: "left", fontSize: "16px" }}
        >
          Modified Entries
        </h4>

        <Row gutter={32} type="flex">
          {changes.map((change, index) => {
            const oldConfig = change.old_value?.zip_codes;
            const newConfig = change.new_value?.zip_codes;
            const oldCities = change.old_value?.city_names;
            const newCities = change.new_value?.city_names;
            const oldFormattedZips = Array.isArray(oldConfig)
              ? oldConfig
              : typeof oldConfig === "string"
              ? oldConfig.split(",").map((zip) => zip.trim())
              : [];
            const newFormattedZips = Array.isArray(newConfig)
              ? newConfig
              : typeof newConfig === "string"
              ? newConfig.split(",").map((zip) => zip.trim())
              : [];
            return (
              <Col span={24} key={index}>
                <div>
                  <Row gutter={[32, 32]} type="flex" className="tagssettingRow">
                    <Row>
                      <Col sm={24} xs={24} md={24} lg={24}>
                        <h4
                          className="ant-typography ant-typography-sm font-medium mb-2"
                          style={{
                            textAlign: "left",
                            color: "#666",
                            fontWeight: "bold",
                          }}
                        >
                          Previous Values
                        </h4>
                        <h4
                          className="ant-typography ant-typography-md font-medium mb-3"
                          style={{ textAlign: "left", fontSize: "16px" }}
                        >
                          Cities
                        </h4>
                        <TagsInput
                          value={oldCities || []}
                          validationRegex={/^(?=[0-9]*$)(?:.{3}|.{4}|.{5})$/}
                          addKeys={[9, 13, 32]}
                          onlyUnique
                          disabled
                          inputProps={{
                            placeholder: null,
                          }}
                        />
                      </Col>
                      <Col span={24}>
                        <h4
                          className="ant-typography ant-typography-md font-medium mb-3"
                          style={{ textAlign: "left", fontSize: "16px" }}
                        >
                          ZipCodes
                        </h4>
                        <TagsInput
                          value={oldFormattedZips || []}
                          validationRegex={/^(?=[0-9]*$)(?:.{3}|.{4}|.{5})$/}
                          addKeys={[9, 13, 32]}
                          onlyUnique
                          disabled
                          inputProps={{
                            placeholder: null,
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={24} xs={24} md={24} lg={24}>
                        <h4
                          className="ant-typography ant-typography-sm font-medium mb-2"
                          style={{
                            textAlign: "left",
                            color: "#666",
                            fontWeight: "bold",
                          }}
                        >
                          Updated Values
                        </h4>
                        <h4
                          className="ant-typography ant-typography-md font-medium mb-3"
                          style={{ textAlign: "left", fontSize: "16px" }}
                        >
                          Cities
                        </h4>
                        <TagsInput
                          value={newCities || []}
                          validationRegex={/^(?=[0-9]*$)(?:.{3}|.{4}|.{5})$/}
                          addKeys={[9, 13, 32]}
                          onlyUnique
                          disabled
                          inputProps={{
                            placeholder: null,
                          }}
                        />
                      </Col>
                      <Col span={24}>
                        <h4
                          className="ant-typography ant-typography-md font-medium mb-3"
                          style={{ textAlign: "left", fontSize: "16px" }}
                        >
                          ZipCodes
                        </h4>
                        <TagsInput
                          value={newFormattedZips || []}
                          validationRegex={/^(?=[0-9]*$)(?:.{3}|.{4}|.{5})$/}
                          addKeys={[9, 13, 32]}
                          onlyUnique
                          disabled
                          inputProps={{
                            placeholder: null,
                          }}
                        />
                      </Col>
                    </Row>
                  </Row>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  };

  const incomingData = data?.difference;
  const incomingAction = data?.action;
  const groupedDifferences = groupDifferencesByAction({
    action: incomingAction,
    difference: incomingData,
  });
  const incomingEntry = incomingData[0]?.new_value ? "New Entry" : "Old Entry";
  return (
    <Row gutter={[16, 32]}>
      <Col span={24}>
        <div className="mt-6">
          <h4
            className="ant-typography ant-typography-md font-medium mb-3"
            style={{ textAlign: "left", fontSize: "18px" }}
          >
            <span style={{ fontSize: "20px", color: "#395484" }}>
              {_.isEmpty(incomingTitle)
                ? `DELIVERY ZIPCODES (${data.reference_name})`
                : incomingTitle}
            </span>
          </h4>
          <div className="mt-6">
            {renderRegularGroup(
              groupedDifferences.REMOVED,
              "Deleted Entry",
              "REMOVED"
            )}
            {renderRegularGroup(
              groupedDifferences.ADDED,
              incomingEntry,
              "ADDED"
            )}
            {renderModifiedGroup(groupedDifferences.MODIFIED)}
          </div>
        </div>
      </Col>
    </Row>
  );
};
